import {SliceComponentType, SliceLike} from '@prismicio/vue';
import {SliceZoneComponents} from '@prismicio/vue';

import CountrySlice from './CountrySlice.vue';
import HeaderLinksSlice from './HeaderLinksSlice.vue';
import HeaderSearchSlice from './HeaderSearchSlice.vue';
import HeaderUserSlice from './HeaderUserSlice.vue';
import Megamenu from './Megamenu.vue';
import MegamenuSubcategory from './MegamenuSubcategory.vue';

function sliceZoneComponent(component: unknown): SliceComponentType<SliceLike> {
    return component as SliceComponentType<SliceLike>;
}

export const components: SliceZoneComponents = {
    country_slice: sliceZoneComponent(CountrySlice),
    header_links_slice: sliceZoneComponent(HeaderLinksSlice),
    header_search_slice: sliceZoneComponent(HeaderSearchSlice),
    header_user_slice: sliceZoneComponent(HeaderUserSlice),
    megamenu: sliceZoneComponent(Megamenu),
    megamenu_subcategory: sliceZoneComponent(MegamenuSubcategory),
};
